module.exports = __webpack_public_path__ + "orbitz-src-icon.png?fa2f22403063fcbcab962a3a9af6a7e7";